import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer fixed-footer">
      <div className="container-fluid">
        <div className="row justify-content-end">
          <div className="col-auto text-center">
            Developed by - D Base Solutions Pvt Ltd &copy; 2025
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
